import { State_update, State_init } from "./State.fs.js";
import { view } from "./View.fs.js";
import { PageHeader } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { Page } from "./Types.fs.js";
import { tryParse } from "../../../fable_modules/fable-library-js.4.19.0/Guid.js";
import { FSharpRef } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { ofArray, tail, head, isEmpty } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { WebPart$3 } from "../../../../Bfs.Web.Portale/WebPart.fs.js";

export const Part = new WebPart$3(State_init, State_update, view, (_arg_1) => (new PageHeader(1, ["BFS Quick Finder"])), (_arg_3) => {
    let matchResult, nummer_2, nummer_3, rechnungid_1;
    if (!isEmpty(_arg_3)) {
        if (head(_arg_3) === "quickfinder") {
            if (!isEmpty(tail(_arg_3))) {
                if (!isEmpty(tail(tail(_arg_3)))) {
                    if (isEmpty(tail(tail(tail(_arg_3))))) {
                        matchResult = 1;
                        nummer_3 = head(tail(_arg_3));
                        rechnungid_1 = head(tail(tail(_arg_3)));
                    }
                    else {
                        matchResult = 2;
                    }
                }
                else {
                    matchResult = 0;
                    nummer_2 = head(tail(_arg_3));
                }
            }
            else {
                matchResult = 2;
            }
        }
        else {
            matchResult = 2;
        }
    }
    else {
        matchResult = 2;
    }
    switch (matchResult) {
        case 0:
            return new Page(0, [nummer_2]);
        case 1: {
            let matchValue;
            let outArg = "00000000-0000-0000-0000-000000000000";
            matchValue = [tryParse(rechnungid_1, new FSharpRef(() => outArg, (v) => {
                outArg = v;
            })), outArg];
            return matchValue[0] ? (new Page(1, [nummer_3, matchValue[1]])) : (new Page(0, [nummer_3]));
        }
        default:
            return undefined;
    }
}, (_arg_2) => {
    if (_arg_2.tag === 1) {
        return ofArray(["quickfinder", _arg_2.fields[0], _arg_2.fields[1]]);
    }
    else {
        return ofArray(["quickfinder", _arg_2.fields[0]]);
    }
}, (_arg) => {
    if (_arg.tag === 5) {
        return _arg.fields[0];
    }
    else {
        return undefined;
    }
});

//# sourceMappingURL=WebPart.fs.js.map
